module.exports = __webpack_public_path__ + "static/img/product_data.f9993cc3.png";